import { FC } from 'react';

type Props = {
	className?: string;
};

const LogoIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='none'
			className={className}>
			<path
				d='M19.3963 16.3368C19.1184 12.5222 18.0964 9.6998 16.4023 7.57095V4.89258C19.472 5.90346 21.5688 11.9996 19.3963 16.3368Z'
				fill='url(#paint0_linear_8173_18323)'
			/>
			<path
				d='M4.60446 7.66248C4.88235 11.4771 5.90435 14.2995 7.59838 16.4283L7.59838 19.1067C4.52868 18.0958 2.4319 11.9996 4.60446 7.66248Z'
				fill='url(#paint1_linear_8173_18323)'
			/>
			<path
				d='M23.9995 11.9998C23.9995 17.0498 20.88 21.3715 16.4625 23.1428C16.4336 23.1544 16.4019 23.1329 16.4019 23.1017V7.57109C18.313 9.41719 19.5156 11.9867 19.5742 14.8275C19.5754 14.8843 19.6569 14.8916 19.6688 14.8361C20.4735 11.0699 19.1185 7.30738 16.4019 4.89272C15.2006 3.82458 13.7326 3.02055 12.0669 2.59598C11.0604 2.33956 10.0504 2.23918 9.06299 2.2805C9.00096 2.2831 8.94922 2.23405 8.94922 2.17196V0.475944C8.94922 0.426085 8.98293 0.382281 9.03125 0.369977C9.98056 0.128237 10.9745 0 11.9993 0C13.5535 0 15.0389 0.295333 16.4019 0.833091C20.8514 2.58904 23.9995 6.92665 23.9995 11.9998Z'
				fill='url(#paint2_linear_8173_18323)'
			/>
			<path
				d='M15.0503 21.8275V23.5235C15.0503 23.5734 15.0165 23.6172 14.9682 23.6295C14.0189 23.8712 13.0249 23.9994 12.0002 23.9994C10.4459 23.9994 8.9606 23.7041 7.59755 23.1664C3.14804 21.4104 0 17.0728 0 11.9997C0 6.9496 3.11947 2.62795 7.53692 0.856644C7.56588 0.845038 7.59755 0.866552 7.59755 0.897745V16.4283C5.68649 14.5823 4.48386 12.0127 4.42526 9.17192C4.42409 9.11515 4.34251 9.10783 4.33064 9.16336C3.52594 12.9296 4.88095 16.6921 7.59755 19.1067C8.79884 20.1749 10.2668 20.9789 11.9326 21.4035C12.939 21.6599 13.9491 21.7603 14.9365 21.7189C14.9985 21.7163 15.0503 21.7654 15.0503 21.8275Z'
				fill='url(#paint3_linear_8173_18323)'
			/>
			<defs>
				<linearGradient
					id='paint0_linear_8173_18323'
					x1='18.3461'
					y1='0.0984988'
					x2='18.3461'
					y2='23.7127'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#D5D5D5' />
					<stop
						offset='0.843575'
						stopColor='#AAAAAA'
					/>
				</linearGradient>
				<linearGradient
					id='paint1_linear_8173_18323'
					x1='5.65466'
					y1='0.0984987'
					x2='5.65466'
					y2='23.7127'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#D5D5D5' />
					<stop
						offset='0.843575'
						stopColor='#AAAAAA'
					/>
				</linearGradient>
				<linearGradient
					id='paint2_linear_8173_18323'
					x1='16.4743'
					y1='-0.055885'
					x2='16.4743'
					y2='23.419'
					gradientUnits='userSpaceOnUse'>
					<stop
						offset='0.106145'
						stopColor='#D5D5D5'
					/>
					<stop
						offset='0.62'
						stopColor='#EEEEEE'
					/>
					<stop
						offset='0.756831'
						stopColor='#F4F4F4'
					/>
					<stop
						offset='1'
						stopColor='#FCFCFC'
					/>
				</linearGradient>
				<linearGradient
					id='paint3_linear_8173_18323'
					x1='7.52513'
					y1='-0.0560103'
					x2='7.52513'
					y2='23.4189'
					gradientUnits='userSpaceOnUse'>
					<stop
						offset='0.106145'
						stopColor='#FCFCFC'
					/>
					<stop
						offset='0.37144'
						stopColor='#F4F4F4'
					/>
					<stop
						offset='0.756831'
						stopColor='#EAEAEA'
					/>
					<stop
						offset='1'
						stopColor='#D5D5D5'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default LogoIcon;
